import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { selectors, actions } from '../sagas/reservation'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Step1 } from './Steps'
import { Step2 } from './Steps'
import { Step3 } from './Steps'
import FormOne from './FormOne'
import FormTwo from './FormTwo'
import FormThree from './FormThree'
import '../stylesheets/Reservations.css'
import 'react-select/dist/react-select.css'
import 'react-datepicker/dist/react-datepicker.css'

class Reservation extends Component {
  constructor(props){
    super(props);
    this.componentCleanup = this.componentCleanup.bind(this);
    this.props.resetFormTwo()
    if (this.props.match &&
        this.props.match.params &&
        this.props.match.params.customer_id) {
      this.props.preloadCustomerInfo(this.props.match.params.customer_id)
    }
  }

  componentCleanup = () => {
    this.props.killReservation()
  }

  componentDidMount(){
    window.addEventListener('beforeunload', this.componentCleanup);
  }

  componentWillUnmount() {
    this.componentCleanup();
    window.removeEventListener('beforeunload', this.componentCleanup);
  }

  render () {
    const { reservation } = this.props
    const { company_id } = this.props.match.params
    return (
      <div className={'reservation-page'}>
        { reservation.step === 1 && <Step1 company_id={company_id}/> }
        { reservation.step === 1 && <FormOne company_id={company_id}/> }
        { reservation.step === 2 && <Step2 company_id={company_id}/> }
        { reservation.step === 2 && <FormTwo company_id={company_id}/> }
        { reservation.step === 3 && <Step3 company_id={company_id}/> }
        { reservation.step === 3 && <FormThree company_id={company_id}/> }
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  reservation: selectors.reservation(store),
  order: selectors.order(store),
  number_of_kegs: selectors.number_of_kegs(store)
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Reservation))



// WEBPACK FOOTER //
// ./src/Reservations/Reservation.jsx